"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageChoiceButton2 = void 0;
const react_1 = __importDefault(require("react"));
const utils_1 = require("../../utils");
const material_1 = require("@mui/material");
const types_1 = require("../types");
const framer_motion_1 = require("framer-motion");
function ImageChoiceButton2({ gameplayStyle, presentation, src, ...rest }) {
    switch (presentation) {
        case types_1.GameplayChoicePresentation.Pending:
            return (react_1.default.createElement(material_1.ThemeProvider, { theme: (0, utils_1.getTheme)(gameplayStyle) },
                react_1.default.createElement(framer_motion_1.motion.div, { animate: { scale: 1.15 }, transition: {
                        repeat: Infinity,
                        repeatType: 'reverse',
                        duration: 1,
                    } },
                    react_1.default.createElement(material_1.Button, { ...rest, size: "large", sx: {
                            padding: 0,
                            overflow: 'clip',
                            ...(0, utils_1.getSquareChoiceButtonSX)(gameplayStyle, presentation, (0, utils_1.getTheme)(gameplayStyle)),
                        } },
                        react_1.default.createElement("img", { src: src, className: "object-cover" })))));
        case types_1.GameplayChoicePresentation.Incorrect:
            return (react_1.default.createElement(material_1.ThemeProvider, { theme: (0, utils_1.getTheme)(gameplayStyle) },
                react_1.default.createElement(framer_motion_1.motion.div, { initial: { opacity: 1, x: 0 }, animate: {
                        x: [0, '-6.54px', '5.54px', '-6.54px', '5.54px', 0],
                        opacity: 0.12,
                    }, transition: {
                        x: { duration: 0.1 },
                        opacity: { delay: 0.1, duratino: 0.3 },
                    } },
                    react_1.default.createElement(material_1.Button, { ...rest, size: "large", sx: {
                            padding: 0,
                            overflow: 'clip',
                            ...(0, utils_1.getSquareChoiceButtonSX)(gameplayStyle, presentation, (0, utils_1.getTheme)(gameplayStyle)),
                        } },
                        react_1.default.createElement("img", { src: src, className: "object-cover" })))));
        case types_1.GameplayChoicePresentation.Eliminated:
            return (react_1.default.createElement(material_1.ThemeProvider, { theme: (0, utils_1.getTheme)(gameplayStyle) },
                react_1.default.createElement(framer_motion_1.motion.div, { animate: { opacity: 0.12 }, transition: { duration: 0.3 } },
                    react_1.default.createElement(material_1.Button, { ...rest, size: "large", sx: {
                            padding: 0,
                            overflow: 'clip',
                            ...(0, utils_1.getSquareChoiceButtonSX)(gameplayStyle, presentation, (0, utils_1.getTheme)(gameplayStyle)),
                        } },
                        react_1.default.createElement("img", { src: src, className: "object-cover" })))));
        default:
            return (react_1.default.createElement(material_1.ThemeProvider, { theme: (0, utils_1.getTheme)(gameplayStyle) },
                react_1.default.createElement(material_1.Button, { ...rest, size: "large", sx: {
                        padding: 0,
                        overflow: 'clip',
                        ...(0, utils_1.getSquareChoiceButtonSX)(gameplayStyle, presentation, (0, utils_1.getTheme)(gameplayStyle)),
                    } },
                    react_1.default.createElement("img", { src: src, className: "object-cover" }))));
    }
}
exports.ImageChoiceButton2 = ImageChoiceButton2;
